import { translations } from "@/lib/translations";

const WORD = { de: "Bild", en: "Photo", es: "Foto", nl: "Foto", pl: "Zdjęcie", fr: "Photo", it: "Foto" };

/** Individueller (KI-)Alt-Text eines Bildes in der Sprache, Fallback Deutsch; "" wenn keiner gepflegt. */
export const ownImageAlt = (property, url, lang = "de") => {
  const a = url && (property?.image_alts || []).find((x) => x.url === url);
  return ((a && (a[lang] || a.de)) || "").trim();
};

/** Bildunterschrift aus der KI-Bildkategorie (Terrasse, Schlafzimmer …); "" wenn nicht kuratiert oder „Sonstiges“. */
export const imageCaption = (property, url, t) => t?.gallery?.[property?.image_categories?.[url]] || "";

/** SEO-Alt-Text: individueller Text "Motiv – Ort, Insel" oder Fallback "Titel – Ort, Insel – Bild 3 / 12". */
export const imageAlt = (property, title, lang = "de", index = null, total = null, url = null) => {
  const island = translations[lang]?.islands?.[property?.island] || translations.de.islands?.[property?.island] || "";
  const place = [property?.location, island].filter(Boolean).join(", ");
  const own = ownImageAlt(property, url, lang);
  if (own) return [own, place].filter(Boolean).join(" – ");
  let alt = [title, place].filter(Boolean).join(" – ");
  if (index != null) alt += ` – ${WORD[lang] || WORD.de} ${index + 1}${total ? ` / ${total}` : ""}`;
  return alt;
};
